import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { CheckBox, DatePicker, Icon, TextBox } from '../../../share/Elements'
import Card from '../../../share/Components/Card/Card'
import {
  RecordAttachItem,
  RecordAttachType,
} from '../../../models/ViewModels/RecordViewModel'
import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import useFetch from '../../../_services/fetch'
import { RaytebRequests } from '../../../_services'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import axios from 'axios'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
interface fileh {
  file: string
}
const RecordAttachment = ({
  item,
  onItemChange,
}: {
  item: RecordAttachType
  onItemChange: (updatedItem: RecordAttachType) => void
}) => {
  const [attachFile, setAttachFile] = useState<RecordAttachItem>({
    dateImport: new Date().toDateString(),
  })
  const [base64String, setBase64String] = useState<string>()
  const [isDone, setIsDone] = useState<boolean>(false)
  const [selectedFile, setSelectedFile] = useState<File | undefined>()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [isLoading, setIsLoading] = useState(false)
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const { reFetch } = useFetch<string, fileh>({
    request: RaytebRequests.Profile_SaveAttachFile_POST({
      token: user.token,
      // headers: { "Content-Type": "multipart/form-data" },
    }),
    onSuccess(data) {
      const updatedItem: RecordAttachItem = {
        ...attachFile,
        url: data,
      }
      setAttachFile(updatedItem)
      if (attachFile) {
        if (data) {
          toast.error('فایل آپلود نشده!')
          return
        }

        const updatedItems = item?.items ? [...item.items] : []
        updatedItems.push(attachFile)

        const updatedItem: RecordAttachType = {
          ...item,
          items: updatedItems,
          showAbstract: false,
        }
        onItemChange(updatedItem)
      }
    },
  })
  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()

      reader.onload = (event) => {
        // The result property contains the base64-encoded string
        const base64Result = event.target!.result
        setBase64String(base64Result?.toString())
      }

      reader.readAsDataURL(file)
      setSelectedFile(file)
      setIsDone(false)
    }

    console.log('Selected File:', file)
  }

  const handleFileUpload = () => {
    // Trigger the file input click programmatically
    fileInputRef.current!.click()
  }

  const handleAddItem = () => {
    if (!selectedFile) {
      toast.error('یک فایل انتخاب کنید!')
      return
    } else if (attachFile?.dateImport === undefined) {
      toast.error('تاریخ را وارد کنید')
    } else if (attachFile?.title === undefined || attachFile?.title === '') {
      toast.error('نام فایل را وارد کنید')
    } else {
      setIsLoading(true)
      const formData = new FormData()
      formData.append(selectedFile.name, selectedFile)
      // `${process.env.REACT_APP_Domain}/api/DoctorProfile/Profile/RecordFileUpload`,
      axios
        .post(
          `${window.env['APP_Domain']}/api/DoctorProfile/Profile/RecordFileUpload`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then((response) => {
          setIsLoading(false)
          const updatedItem: RecordAttachItem = {
            ...attachFile,
            url: response.data,
          }
          setAttachFile(updatedItem)
          if (attachFile) {
            if (!response.data) {
              toast.error('فایل آپلود نشده!')
              return
            }
            if (response.data.includes('error')) {
              toast.error('فایل آپلود نشده!')
              return
            }
            const updatedItems = item?.items ? [...item.items] : []
            updatedItems.push(updatedItem)

            const updatedRecordAttach: RecordAttachType = {
              ...item,
              items: updatedItems,
              showAbstract: false,
            }
            onItemChange(updatedRecordAttach)
            setSelectedFile(undefined)
            setAttachFile({ dateImport: new Date().toDateString() })
            setIsDone(true)
          }
        })
        .catch((error) => {
          setIsLoading(false)
          console.error('Error uploading file:', error.message)
        })
      // reFetch({
      //   file: base64String!,
      // });
    }
  }
  const handleAbstractClick = (index: number) => {
    debugger
    const updatedItems = [...(item?.items || [])]
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    }

    const checkupData: RecordAttachType = {
      ...item,
      items: updatedItems,
    }
    onItemChange && onItemChange(checkupData)
  }
  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item.items || [])]
    updatedItems.splice(index, 1)

    const updatedObject = { ...item, items: updatedItems }

    onItemChange && onItemChange(updatedObject)
  }
  useEffect(() => {
    console.log('base64: ', base64String)
  }, [base64String])

  return (
    <>
      <div className='p-4'>
        {isLoading ? (
          <SkeletonTheme>
            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>

            <div className='mb-5'>
              <Skeleton height={60} width={'100%'} />
            </div>
          </SkeletonTheme>
        ) : (
          <>
            <div className='grid grid-cols-7 gap-5'>
              <div className='col-span-3'>
                <TextBox
                  innerText='عنوان فایل'
                  Type={TextBoxTypeEnum.Text}
                  debounceTime={0}
                  className='w-full '
                  isRequired={true}
                  value={attachFile?.title ? attachFile?.title : ''}
                  onChange={(e) => {
                    const updatedItem: RecordAttachItem = {
                      ...attachFile,
                      title: e.target.value,
                    }
                    setIsDone(false)
                    setAttachFile(updatedItem)
                  }}
                />
              </div>
              <div className='col-span-4 flex gap-1 text-disable'>
                {/* <Icon icon="rayteb-microphone" className="text-xl" /> */}
                {selectedFile === undefined ? (
                  <div
                    className={`p-2 flex flex-col items-center gap-2 bg-violet-50 text-primary rounded-lg hover:bg-violet-100 cursor-pointer`}
                  >
                    <label>
                      <Icon icon='rayteb-attach' className='text-xl' />
                      <input
                        type='file'
                        // ref={fileInputRef}
                        className='hidden'
                        onChange={handleFileChange}
                      />
                    </label>
                    <button onClick={handleFileUpload}></button>
                  </div>
                ) : (
                  <div className='p-2 flex items-center flex-row gap-2 bg-violet-50 text-secondaryLight rounded-lg hover:bg-violet-100 cursor-pointer'>
                    <Icon
                      onClick={handleFileUpload}
                      icon='rayteb-file'
                      className='text-xl'
                    />
                    <span className='text-xs'>{selectedFile?.type!}</span>
                  </div>
                )}
              </div>

              <div className='col-span-3'>
                <DatePicker
                  innerText='تاریخ'
                  isRequired={true}
                  className=''
                  name='Date'
                  id='Date'
                  raytebValue={attachFile?.dateImport}
                  value={
                    attachFile?.dateImport
                      ? new Date(attachFile.dateImport!).toShamsi()
                      : ''
                  }
                  onChange={(e) => {
                    const fromDateInput = document.getElementById('Date') // Assuming you have an element with id "toDate"
                    const raytebValue =
                      fromDateInput?.getAttribute('rayteb-value')
                    const updatedItem: RecordAttachItem = {
                      ...attachFile,
                      dateImport: raytebValue!,
                    }
                    setIsDone(false)
                    setAttachFile(updatedItem)
                  }}
                />
              </div>
              <div className='col-span-4'>
                <div className='flex justify-between items-center mt-3 px-1'>
                  <div className='mr-3 mb-2'>
                    <label className='text-secondary text-sm'>
                      نمایش در پرونده
                    </label>
                    <input
                      type='checkbox'
                      className='m-1 text-sm'
                      checked={item?.showAbstract}
                      onChange={() =>
                        onItemChange({
                          ...item,
                          showAbstract: !item?.showAbstract!,
                          items: item?.items!,
                        })
                      }
                    ></input>
                  </div>

                  <Icon
                    icon='rayteb-add-circular'
                    className='text-2xl text-primaryLight'
                    onClick={handleAddItem}
                  />
                </div>
              </div>
            </div>
            <div className='mt-5 grid grid-cols-1 gap-1 '>
              {item.items?.map((n, i) => (
                <Card
                  key={i}
                  className='!text-start w-full text-xs text-primaryLight font-bold'
                  text={n.title}
                  footer={
                    <CardFooter
                      attachfile={n}
                      onAbstractClick={() => handleAbstractClick(i)}
                      onDeleteClick={() => handleDeleteClick(i)}
                    />
                  }
                >
                  <div className=' flex xs:flex-col flex-row'>
                    <a
                      className='text-xs text-primary font-bold ml-2 '
                      href={`${window.env['APP_Rayteb_Domain']}/cdn/${n.url}`}
                      target='_blank'
                      rel='noreferrer'
                    >
                      <i className='rayteb-download text-2xl'></i>
                    </a>
                  </div>
                </Card>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  )
}

const CardFooter = ({
  attachfile,
  onAbstractClick,
  onDeleteClick,
}: {
  attachfile?: RecordAttachItem
  onAbstractClick: () => void
  onDeleteClick: () => void
}) => (
  <>
    <div className='w-full flex justify-between items-center'>
      <span className='text-xs text-primaryLight'>
        {new Date(attachfile?.dateImport!).toShamsi()}
      </span>
      <div className='flex justify-center itmes-center gap-2'>
        <Icon
          icon='rayteb-delete'
          className='text-xl text-primary'
          onClick={onDeleteClick}
        />
        <Icon
          icon='rayteb-medical-ophthalmology'
          className={`text-xl  ${attachfile?.showAbstract ? 'text-primary' : 'text-disable'
            }`}
          onClick={onAbstractClick}
        />
      </div>
    </div>
  </>
)
export default RecordAttachment
